import { render, staticRenderFns } from "./chooselabel.vue?vue&type=template&id=2c86fff0&scoped=true"
import script from "./chooselabel.vue?vue&type=script&lang=js"
export * from "./chooselabel.vue?vue&type=script&lang=js"
import style0 from "./chooselabel.vue?vue&type=style&index=0&id=2c86fff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86fff0",
  null
  
)

export default component.exports